import { Fragment } from "react";
import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/shared/uikit/Button";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { useCheckoutTabContext } from "../CheckoutTabContext";
import { BuilderSidebar } from "../components/BuilderSidebar";
import { PROPERTIES, localeRoot } from "../constants";
import { DefaultProperties } from "./Properties/DefaultProperties";
import { TestimonialProperties } from "./Properties/TestimonialProperties";

export const Sidebar = () => {
  const { goBack, history, currentSidebar } = useCheckoutTabContext();

  // TODO: CHANGE ME TO AN ICON
  const goBackString = "Go back";

  const sidebarContentMapping = {
    [PROPERTIES.DEFAULT]: DefaultProperties,
    [PROPERTIES.TESTIMONIALS]: TestimonialProperties,
  };

  const SidebarContent = sidebarContentMapping[currentSidebar] || Fragment;

  return (
    <BuilderSidebar className="flex w-[328px] flex-col gap-y-5">
      <div className="border-primary flex flex-row gap-x-2 border-b px-6 py-5">
        {history.length > 1 && <Button onClick={goBack}>{goBackString}</Button>}
        <Typography.LabelMd weight="semibold">
          {t([localeRoot, "builder.default.title"])}
        </Typography.LabelMd>
      </div>
      <SidebarContent />
    </BuilderSidebar>
  );
};
